<template>
  <b-card
    tag="article"
    class="location-card"
  >
    <div class="d-lg-flex flex-lg-column h-100">
      <h2 class="h3 mb-3">{{ title }}</h2>
      <ul class="list-unstyled">
        <li>{{ telephoneLabel }} <a class="grey-link" :href="'tel:'+telephone">{{
          telephone
          }}</a></li>
        <li>{{ emailLabel }} <a class="grey-link" :href="'mailto: '+email">{{
          email
          }}</a></li>
      </ul>
      <a :href="url" class="btn btn-secondary btn-rounded mt-lg-auto">{{
        urlLabel
        }}</a>
      <img :src="'/images/country-maps/'+slug+'.svg'"
           class="country-map-card"
           :alt="title">
    </div>
  </b-card>
</template>

<script>
export default {
  name: 'Locations',
  props: {
    title: {
      type: String,
      default: null
    },
    telephone: {
      type: String,
      default: null
    },
    telephoneLabel: {
      type: String,
      default: null
    },
    email: {
      type: String,
      default: null
    },
    emailLabel: {
      type: String,
      default: null
    },
    url: {
      type: String,
      default: null
    },
    urlLabel: {
      type: String,
      default: null
    },
    slug: {
      type: String,
      default: null
    }
  }
}
</script>
